import styled from 'styled-components';

const StyledBadge = styled.span`
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  background-color: ${(props) => props.bg || '#e5e5e5'};
  color: ${(props) => props.color || '#333'};
  font-size: 0.875rem;
  font-weight: 500;
`;

export default function Badge({ children, bg, color }) {
  return <StyledBadge bg={bg} color={color}>{children}</StyledBadge>;
}
